module.exports = __webpack_public_path__ + "static/media/tr.f253a02f.svg";